import React, { useState, useEffect } from "react";

export default function CheckBoxExpectations({ register, errors }) {
  const fieldName = "websiteexpectations";
  const [showNewChoice, setShowNewChoice] = useState(false);

  useEffect(() => {
    register(`${fieldName}.other`); // Register the field outside the render method
  }, [register]);

  return (
    <fieldset>
      <legend className="wdc-field-label">
        What do you want this new site to do? (choose as many as you like)
      </legend>

      <div className="space-y-2.5">
        {[
          { value: "explain", label: "Explain your products and services" },
          { value: "brand", label: "Increase Brand Awareness" },
          {
            value: "presence",
            label:
              "Improve online presence with a modern and mobile responsive website",
          },
          { value: "leads", label: "Generate leads and enquiries" },
          { value: "sales", label: "Generate sales directly on the website" },
          { value: "all", label: "All of the above" },
        ].map((item) => (
          <label
            key={item.value}
            htmlFor={`${fieldName}-${item.value}`}
            className="wdc-option"
          >
            <input
              id={`${fieldName}-${item.value}`}
              type="checkbox"
              className="wdc-check"
              value={item.value}
              {...register(`${fieldName}.${item.value}`, { required: false })}
            />
            <span className="wdc-option-label">{item.label}</span>
          </label>
        ))}

        <label htmlFor={`${fieldName}-other`} className="wdc-option">
          <input
            id={`${fieldName}-other`}
            type="checkbox"
            className="wdc-check"
            value="other"
            onChange={(e) => setShowNewChoice(e.target.checked)}
          />
          <span className="wdc-option-label">Add new choice</span>
        </label>

        {errors[fieldName] && (
          <span className="wdc-error">This field is required</span>
        )}
      </div>

      {showNewChoice && (
        <div className="mt-3">
          <input
            type="text"
            placeholder="Enter new choice"
            className="wdc-field"
            {...register(`${fieldName}.otherText`)}
          />
        </div>
      )}
    </fieldset>
  );
}
